// Simple drag-to-scroll for reviews slider (desktop only)
const grids = document.querySelectorAll('.reviews-slider__grid');

if (grids.length > 0 && window.innerWidth >= 768) {
    grids.forEach(grid => {
        let isDragging = false;
        let startX;
        let scrollLeft;

        grid.addEventListener('mousedown', (e) => {
            isDragging = true;
            grid.style.cursor = 'grabbing';
            startX = e.pageX - grid.offsetLeft;
            scrollLeft = grid.scrollLeft;
        });

        grid.addEventListener('mouseleave', () => {
            isDragging = false;
            grid.style.cursor = 'grab';
        });

        grid.addEventListener('mouseup', () => {
            isDragging = false;
            grid.style.cursor = 'grab';
        });

        grid.addEventListener('mousemove', (e) => {
            if (!isDragging) return;
            e.preventDefault();
            const x = e.pageX - grid.offsetLeft;
            const walk = (x - startX) * 2;
            grid.scrollLeft = scrollLeft - walk;
        });
    });
}
